import {
  Autocomplete,
  FormControl,
  FormHelperText,
  InputLabel,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { Controller } from "react-hook-form";

import style from "./Input.module.css";

const FormInputComboBox = ({
  name,
  label,
  options,
  control,
  rules,
  error,
  required,
  onChange = () => void 0,
}) => {
  return (
    <Box className={style.control}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <Autocomplete
            {...field}
            disablePortal
            autoHighlight
            clearOnEscape
            blurOnSelect
            isOptionEqualToValue={(option, value) => option.id === value.id}
            options={options}
            onChange={(e, value) => {
              field.onChange(value);
              onChange();
            }}
            renderInput={(params) => (
              <TextField
                required={required}
                {...params}
                error={error !== undefined}
                label={label}
                size="small"
                helperText={error}
              />
            )}
            renderOption={(props, option) => {
              return (
                <li {...props} key={option.id}>
                  {option.label}
                </li>
              );
            }}
          />
        )}
      />
    </Box>
  );
};

export default FormInputComboBox;
